import styled from 'styled-components';

export const StyledCenteredParagraph = styled.p`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
